const React = require('react');


module.exports = (props) => {
  return (
    <div
      {...props}
      className={`h45 layoutRow fhaC fvaC f12 fw4 lts0em ttU c00F `
        + (props.className || '')}
    >
      <div
        className="c0 wsNW tov ov tc w"
      >{props.children}</div>
    </div>
  );
};
